import ReactOnRails from 'react-on-rails/client';
import PrivacyPolicyShow from '../../bundles/public/privacy_policies/ror_components/PrivacyPolicyShow.tsx';

ReactOnRails.register({PrivacyPolicyShow});